<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>Import File</h2>

<mat-dialog-content>

  <input type="file"
         accept=".txt, .csv"
         (change)="onFileSelected($event)"
         style="margin-top: 10px;">

  <div *ngIf="error" style="color: red; margin-top: 10px;">
    {{ error }}
  </div>

  <div *ngIf="fileContent" style="margin-top: 15px;">
    <h4>Preview:</h4>
    <pre style="background: transparent; padding: 10px; max-height: 200px; overflow: auto;">
{{ fileContent }}
    </pre>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="importFile()" [disabled]="!fileContent">
    Import
  </button>
</mat-dialog-actions>
</div>